import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  rootContainer: (props: any) => ({
    width: "100%",
  }),
  expandedListClass: (props: any) => ({
    border: `0.5px solid ${props?.palette?.dashboardList?.darkPurple}`,
    background: props?.palette?.dashboardList?.lightPurple2,
    margin: 10,
    padding: 10,
    borderRadius: 5,
    cursor: "pointer",
  }),
  collapsedListClass: (props: any) => ({
    border: `0.5px solid ${props?.palette?.dashboardList?.darkPurple}`,
    margin: 10,
    padding: 10,
    borderRadius: 5,
    cursor: "pointer",
  }),
  itemTitleStyle: (props: any) => ({
    textTransform: "uppercase",
    color: props?.palette?.dashboardList?.black,
    fontSize: "14px",
    fontWeight: 800,
    marginBottom: 8,
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  itemAreaStyle: (props: any) => ({
    color: props?.palette?.dashboardList?.collapsedListSubtitle, // darkGrey3
    fontSize: 13,
    fontWeight: 700,
    marginBottom: "5px",
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  explandedListStyle: (props: any) => ({
    background: props?.palette?.dashboardList?.white, // colorWhite
    fontSize: 13,
    fontWeight: 700,
    margin: 10,
    padding: 10,
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  displayFlex: (props: any) => ({
    display: "flex",
    justifyContent: "space-between",
  }),
  itemListCount: (props: any) => ({
    color: props?.palette?.dashboardList?.black,
    fontSize: "14px",
    fontWeight: 800,
    margin: "5px 0px 0px 0px",
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  itemListName: (props: any) => ({
    color: props?.palette?.dashboardList?.darkGrey4, // 6B6B6B
    fontSize: "13px",
    fontWeight: 700,
    margin: "5px 0px 10px 0px",
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  selectedButtonStyles: (props: any) => ({
    backgroundColor: `${props?.palette?.dashboardList?.darkPurple2} !important`,
    borderRadius: "15px !important",
    fontSize: "13px !important",
    lineHeight: "16px !important",
    boxShadow: "none !important",
    fontWeight: 700,
    textTransform: "none",
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  timeStampStyle: (props: any) => ({
    color: props?.palette?.dashboardList?.darkGrey3,
    fontSize: "13px !important",
    fontWeight: 500,
    alignSelf: "center",
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  itemListIconStyle: (props: any) => ({
    marginRight: 5,
  }),
  connectedStatusButtonStyle: (props: any) => ({
    padding: 5,
    borderRadius: 5,
    background: props?.palette?.dashboardList?.connectedButtonBackground,
    color: props?.palette?.dashboardList?.connectedButtonFont,
    fontSize: "12px !important",
    fontWeight: 700,
  }),
  disConnectedStatusButtonStyle: (props: any) => ({
    padding: 5,
    borderRadius: 5,
    background: props?.palette?.dashboardList?.disconnectedButtonBackground,
    color: props?.palette?.dashboardList?.disconnectedButtonFont,
    fontSize: "12px !important",
    fontWeight: 700,
    fontFamily: `'Nunito Sans', sans-serif !important`,
  }),
  connectedButtonPosition: (props: any) => ({
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: -10,
  }),
});
export default useStyles;
